import { Divider } from '@tunasong/ui-lib'
import { logger } from '@tunasong/models'
import { GuitarLib, ScaleLib } from '@tunasong/music-lib'
import { GuitarPatterns, ScaleSelect, usePageScale } from '@tunasong/music-ui'
import { usePageMetadata } from '@tunasong/tunasong-ui'
import { useSearchParams } from '@tunasong/ui-lib'
import { useEffect, useEffectEvent, type FC } from 'react'
import styles from './guitar-patterns-page.module.css'

export interface GuitarPatternsPageProps {}

interface PatternSearchParams {
  groupId: string
  patternIdx: number
}

const groups = GuitarLib.scalePatterns

export const GuitarPatternsPage: FC<GuitarPatternsPageProps> = props => {
  const {} = props

  const [scale, setScale] = usePageScale({ root: 'C', type: 'major' })
  const { setName } = usePageMetadata()
  const [searchParams, setSearchParams] = useSearchParams()

  const patternSpec = searchParams.get('pattern')
  const groupPatternParams = patternSpec ? (JSON.parse(decodeURIComponent(patternSpec)) as PatternSearchParams) : null
  const patternIdx = groupPatternParams?.patternIdx ?? 0
  const group =
    Object.values(groups).find(g => g.id === groupPatternParams?.groupId) ?? GuitarLib.scalePatterns.fivePatternSystem

  const updatePattern = ({ group, patternIdx }: { group: GuitarLib.GuitarPatternSpecGroup; patternIdx: number }) => {
    const pattern = group?.shapes[patternIdx]

    try {
      setSearchParams(
        prev => ({
          ...Object.fromEntries(prev.entries()),
          pattern: encodeURIComponent(JSON.stringify({ groupId: group.id, patternIdx })),
        }),
        {
          replace: true,
        }
      )
      // Set the name of the page
      const title = `${ScaleLib.getName(scale)} ${pattern.name}`
      setName(title)
    } catch (e) {
      logger.error('Invalid page scale params', pattern.name, e)
    }
  }

  const updatePatternEvent = useEffectEvent(updatePattern)

  useEffect(() => {
    updatePatternEvent({ group, patternIdx })
  }, [group, patternIdx])

  return (
    <>
      <ScaleSelect
        variant="all"
        value={scale}
        onChange={scale => {
          setScale(scale)
        }}
      />

      <Divider className={styles.divider} />

      <GuitarPatterns
        scale={scale}
        groups={[GuitarLib.scalePatterns.fivePatternSystem]}
        selectedPattern={{ group, patternIdx }}
        onSelectedPattern={updatePattern}
      />
    </>
  )
}
